// @core/api/endpoints/userprofile/list_userprofiles_admin.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUserprofilesAdminResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List all user profiles (admin)
 * Returns a paginated list of all user profiles on the platform regardless of privacy settings. Requires platform admin privileges.
 */
export async function ListUserprofilesAdmin(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListUserprofilesAdminResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/admin`;
  const requestOptions = options;
  return client.get<ListUserprofilesAdminResponse>(requestPath, { ...requestOptions, params });
}
